import Vue from 'vue';
import template from './customerSignup.vue';
import { Component, Provide, Watch } from 'vue-property-decorator';
import BreadcrumbStageHeader from '../../components/breadcrumbStageHeader';
import MainButtonSet from '../../components/mainButtonSet';
import * as $ from 'jquery';
import commonUtilService from '../../services/commonUtil/commonUtilService';
import DefaultModal from '../../components/modal';
import OneButtonModal from '../../components/oneButtonModal';
import AccountDetail from '../../components/accountDetail';
import tmsService from '../../services/axios/tmsService';
import Autocomplete from 'vue2-autocomplete-js';
import qs from 'qs';
@Component({
    mixins: [template],
    components: {
        BreadcrumbStageHeader,
        MainButtonSet,
        DefaultModal,
        OneButtonModal,
        AccountDetail,
        Autocomplete,
    },
})
export default class CustomerSignup extends Vue {
    // Error Modal
    errorModal: string = 'customerSignupErrorModel';
    @Provide()
    errorWidth: number = 423;
    errorModalTitle: string = 'Error';
    modalLocationName: string = 'locationModalError';
    showLocationModal() {
        this.$modal.show(this.modalLocationName);
        this.closeModal();
    }
    closeLocationModal() {
        this.$modal.hide(this.modalLocationName);
    }
    closeSignupErrorModal() {
        this.$modal.hide(this.errorModal);
    }
    showXBtn: boolean = false;
    get createAccountError() {
        return this.$store.getters.getCreateAccountError;
    }
    // watch
    @Watch('createAccountError', { deep: true, immediate: true })
    onForgotPasswordSend(val: any, oldVal: any, event: any) {
        if (val != 0 && val != oldVal) {
            this.$modal.show(this.errorModal);
        }
    }

    // nav header
    get breadcrumbStageHeader() {
        return this.$store.getters.customerSignupHeader;
    }
    // nav header

    get formData() {
        return this.$store.getters.customerSignupBody;
    }

    get accountLength() {
        if (this.$store.getters.customerSignupBody.signupPart.accounts) {
            return this.$store.getters.customerSignupBody.signupPart.accounts.length;
        } else {
            return 1;
        }
    }

    get currentStage() {
        return this.$store.getters.currentStage;
    }

    get stateArray() {
        return commonUtilService.getStateArrayAbbr();
    }

    sameAsShippingAddressChanged() {
        this.$store.dispatch('sameAsShippingAddressChanged');
    }

    async getLocationList(inputValue: any) {
        if (inputValue && inputValue.length > 3) {
            let response = await tmsService.post(
                'write_new/get_customer_signup_locations.php',
                qs.stringify({ search_term: inputValue, location_type: 1 })
            );
            if (response && response.data) {
                return response.data;
            } else {
                return [];
            }
        } else {
            return [];
        }
    }

    onShippingSameAsAddressInput() {
        if (this.formData.signupPart.sameAsShippingAddress) {
            this.$store.dispatch('syncBillingInfoOnInput');
        }
    }

    onShipperCompanySelect(value: any) {
        if (value && value['location_id']) {
            this.formData.signupPart.shipInfo.locationId = value['location_id'];
            this.$store.dispatch(
                'initCustomerSignup',
                this.formData.signupPart.shipInfo.locationId
            );
        } else {
            if (value && value['location_name']) {
                this.formData.signupPart.shipInfo.company = value['location_name'];
            }

            if (this.formData.signupPart.sameAsShippingAddress) {
                this.$store.dispatch('syncBillingInfoOnInput');
            }
        }
    }

    onAutocompleteInput(val: any) {
        this.$store.dispatch('updateShipInfoCompany', val);
    }

    // btn action
    signupCancel() {
        this.showModal();
    }
    signupBack() {
        this.$store.dispatch('updateStage', { currentStage: this.currentStage - 1 });
    }

    async signupNext() {
        let result = await this.$validator.validateAll('form-signup');
        if (result) {
            this.$store.dispatch('updateStage', { currentStage: 2 });
            $('html,body').animate({ scrollTop: '0px' }, 300);
        }
    }

    async addInfoNext() {
        let result = await this.$validator.validateAll('form-addinfo');
        if (result) {
            this.$store.dispatch('updateStage', { currentStage: 3 });
            $('html,body').animate({ scrollTop: '0px' }, 300);
        }
    }

    addInfoCancel() {
        this.$store.dispatch('updateStage', { currentStage: 1 });
    }

    reviewCancel() {
        this.showModal();
    }

    async reviewCreateAccount() {
        let result01 = await this.$validator.validateAll('form-signup');
        if (!result01) {
            this.$store.dispatch('updateStage', { currentStage: 1 });
            return;
        }
        let result02 = await this.$validator.validateAll('form-addinfo');
        if (!result02) {
            this.$store.dispatch('updateStage', { currentStage: 2 });
            return;
        }
        this.$store.dispatch('createAccount', this.formData);
    }

    editButtonClick() {
        this.$store.dispatch('updateStage', { currentStage: 1 });
    }
    // btn action

    mounted() {
        this.$store.dispatch('clearCustomerSignup');
        if (this.$route.query.shipperLocationId) {
            this.$store.dispatch('initCustomerSignup', this.$route.query.shipperLocationId);
        }
    }

    // watch
    @Watch('formData.signupPart.shipInfo.company', { deep: true, immediate: true })
    onShipInfoCompany(val: any, oldVal: any, event: any) {
        if (val != 0 && val != oldVal) {
            if (this.$refs.myAutocomplete) {
                let myAutocomplete: any = this.$refs.myAutocomplete;
                myAutocomplete.setValue(this.formData.signupPart.shipInfo.company);
            }
        }
    }

    onAutocompleteFocus(e: FocusEvent) {
        if (this.$refs.myAutocomplete) {
            let myAutocomplete: any = this.$refs.myAutocomplete;
            myAutocomplete.showList = true;
        }
    }

    // Modal
    @Provide()
    modalName: string = 'cancelSignup';

    @Provide()
    modalMessage: string = `Are you sure you want to cancel this customer signup?`;

    @Provide()
    modalTitle: string = 'Cancel Signup';

    @Provide()
    modalConfirmText: string = 'yes, cancel signup';

    @Provide()
    modalCancelText: string = 'Nevermind';

    @Provide()
    maxWidth: number = 700;

    @Provide()
    width: number = 600;

    @Provide()
    maxHeight: number = 250;
    @Provide()
    height: number = 250;
    showModal() {
        this.$modal.show(this.modalName);
    }

    closeModal() {
        this.$modal.hide(this.modalName);
    }

    confirmModal() {
        this.$store.dispatch('clearCustomerSignup');
        this.closeModal();
        window.location.href = '#/home';
    }

    addAccountLine() {
        this.$store.dispatch('addAccountLine');
    }
    // Modal
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/customerSignup/index.ts